const AUTH_SESSION_KEY = "authSession";

/** Mark this browser tab as authenticated after a successful login or registration. */
export function setAuthSession(user) {
    const userId = user?._id ?? user?.id;
    const role = user?.role;
    if (!userId || !role) return;
    try {
        sessionStorage.setItem(
            AUTH_SESSION_KEY,
            JSON.stringify({ userId: String(userId), role: String(role) }),
        );
    } catch {
        /* ignore quota / private mode */
    }
}

export function clearAuthSession() {
    try {
        sessionStorage.removeItem(AUTH_SESSION_KEY);
    } catch {
        /* ignore */
    }
}

function readAuthSession() {
    try {
        const raw = sessionStorage.getItem(AUTH_SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

/** True only after password login or successful registration in this tab. */
export function isAuthSessionValid(user) {
    if (!user) return false;
    const session = readAuthSession();
    if (!session?.userId) return false;
    const id = String(user._id ?? user.id ?? "");
    return Boolean(id) && session.userId === id;
}
